import classNames from "classnames";
import { PropsWithChildren } from "react";

export type Position = "first" | "middle" | "last";

type QuestionWrapperProps = {
  id: string;
  question: string | JSX.Element;
  className?: string;
  direction?: "row" | "column";
  position?: Position;
};

// see if local storage has a key to show the id
const SHOULD_SHOW_ID = localStorage.getItem("SHOULD_SHOW_ID") === "true";

export const Question: React.FC<PropsWithChildren<QuestionWrapperProps>> = ({
  id,
  children,
  className,
  question,
  position,
  direction = "row",
}) => {
  return (
    <div
      className={classNames(
        "gap-2 sm:gap-4 items-center max-w-full",
        className,
        {
          "flex flex-col items-stretch": direction === "column",
          "grid grid-cols-1 sm:grid-cols-[5fr,2fr]": direction === "row",
          "pb-5": position === "first",
          "py-5": position === "middle",
          "pt-5": position === "last",
        },
      )}
    >
      <span className="text-base font-medium text-gray-800">
        {SHOULD_SHOW_ID ? `${id} - ` : ""}
        {question}
      </span>
      <div>{children}</div>
    </div>
  );
};
